<template>
  <data-table
    :headers="tableHeaders"
    :route="{ name: 'content.pages.edit', params: ['id'] }"
    v-bind="$props"
    v-on="$listeners"
  >
    <template #item="{ item }">
      <td class="text-center">
        <flag-pip :flag="item.language.flag" :text="item.language.name" show-label class="mt-2" />
      </td>
      <td>
        <div>{{ getPage(item) }}</div>
        <div class="text-caption">{{ getSite(item) }}</div>
      </td>
      <td>{{ getEntities(item) }}</td>
      <td :title="item.meta.headline">{{ truncate(item.meta.headline, 25) || '-' }}</td>
      <td>
        <div class="d-flex align-center justify-space-between">
          <published-chip :value="item.wp_publish_status" small />
          <v-tooltip v-if="item.is_revised" color="grey darken-3" bottom small>
            <template #activator="{ on }">
              <v-icon small color="grey darken-3" class="ml-2" v-on="on">rate_review</v-icon>
            </template>
            <span>Has revised changes</span>
          </v-tooltip>
        </div>
      </td>
      <td>
        <div v-if="item.published_at">
          <div>{{ formatDate(item.published_at) }}</div>
          <div class="text-caption">{{ formatTime(item.published_at) }}</div>
        </div>
        <span v-else>-</span>
      </td>
    </template>
    <template #actions="{ item: item }">
      <v-list-item :disabled="!item.wp_permalink" @click="openInNewTab(item.wp_permalink)">
        <v-list-item-title>
          <v-icon left small>launch</v-icon>
          <span>Preview in new tab</span>
        </v-list-item-title>
      </v-list-item>
    </template>
  </data-table>
</template>

<script>
// Helpers
import { truncate } from '@/utils/string'
import { formatDate, formatTime } from '@/utils/date'
import getOptionKeyByValue from '@/utils/get-option-key-by-value'
// Components
import { VDataTable } from 'vuetify/lib'
import DataTable from '@/components/data-table'
import FlagPip from '@/views/news-articles/components/flag-pip'
import PublishedChip from '@/views/news-articles/components/published-chip'

export default {
  name: 'NewsArticleTable',
  components: {
    DataTable,
    FlagPip,
    PublishedChip,
  },
  extends: VDataTable,
  data: () => ({
    tableHeaders: [
      { text: 'Language', value: 'language' },
      { text: 'Page/Site', value: 'page' },
      { text: 'Entities', value: 'entities' },
      { text: 'Headline', value: 'headline', width: '150' },
      { text: 'Status', value: 'status' },
      { text: 'Publish Date', value: 'published' },
      { value: 'actions' },
    ],
  }),
  methods: {
    formatDate,
    formatTime,
    getOptionKeyByValue,
    truncate,
    getEntities(item) {
      return item.entities.map(({ entity: { default: { name } } = {} }) => name).join('/')
    },
    getPage(item) {
      return item.pageType.name
    },
    getSite(item) {
      return item.site.hostname
    },
    openInNewTab(url) {
      window.open(url, '_blank').focus()
    },
  },
}
</script>
<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}
</style>
